<div edsGrid>
  <eds-divider
    [class]="containerClass"
    [theme]="dividerTheme"
    [margin]="margin"
  >
  </eds-divider>
</div>
